// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusCountScroll {
  overflow-x: auto;
  white-space: nowrap;
}

.company-card {
  background: #f5f7fa;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  font-family: Arial, sans-serif;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.company-card .company-header {
  background: #7fc5c4;
  color: #222;
  padding: 8px 12px;
  font-weight: bold;
  font-size: 14px;
}
.company-card .company-body {
  padding: 8px 0px;
}
.company-card .company-body .company-item {
  font-size: 20px;
  font-weight: medium;
  padding: 4px 12px;
  color: #333;
  transition: background 0.3s;
}
.company-card .company-body .company-item:hover {
  background: #7fc5c4;
  cursor: pointer;
}

.ledger-table .table-data .company-body .company-item {
  color: #333;
}
.ledger-table .table-data .company-body .company-item:hover {
  cursor: pointer;
}
.ledger-table .table-data .company-body .company-item:hover span {
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app/Customer_V2/CustomReport/component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;AACF;;AACA;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,wCAAA;AAEF;AAAE;EAIE,mBAAA;EACA,WAAA;EAEA,iBAAA;EACA,iBAAA;EACA,eAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAKI;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,2BAAA;AAHN;AAKM;EAIE,mBAAA;EAEA,eAAA;AAPR;;AAgBM;EACE,WAAA;AAbR;AAeQ;EAEE,eAAA;AAdV;AAgBU;EACE,WAAA;AAdZ","sourcesContent":[".statusCountScroll {\n  overflow-x: auto;\n  white-space: nowrap;\n}\n.company-card {\n  background: #f5f7fa;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  width: 100%;\n  font-family: Arial, sans-serif;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .company-header {\n    // background: #f1c40f;\n    // background: rgba(34, 139, 34, 0.231372549);\n    // color: #008000;\n    background: #7fc5c4;\n    color: #222;\n    // color: #222;\n    padding: 8px 12px;\n    font-weight: bold;\n    font-size: 14px;\n  }\n\n  .company-body {\n    padding: 8px 0px;\n\n    .company-item {\n      font-size: 20px;\n      font-weight: medium;\n      padding: 4px 12px;\n      color: #333;\n      transition: background 0.3s;\n\n      &:hover {\n        // background: #f1c40f;\n        // background: rgba(34, 139, 34, 0.231372549);\n        // color: #008000;\n        background: #7fc5c4;\n\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.ledger-table {\n  .table-data {\n    .company-body {\n      .company-item {\n        color: #333;\n\n        &:hover {\n          // background: #7fc5c4;\n          cursor: pointer;\n\n          span {\n            color: #333;\n          }\n        }\n      }\n    }\n  }\n}\n\n// .ledger-table {\n//    .table-data {\n//     .company-body {\n//       .company-item {\n\n//         padding: 0.5rem;\n//         border-radius: 4px;\n\n//         &:hover {\n//           background-color: #7fc5c4; // Hover color\n//           cursor: pointer;\n\n//           span {\n//             color: #333; // Optional: adjust text color on hover\n//           }\n//         }\n//       }\n//     }\n//   }\n// }\n\n// .ledger-table {\n//  .rdt_TableCell{\n//           background-color: #7fc5c4; // teal-like hover color\n\n//  }\n//   .table-data {\n//     .company-body {\n//       .company-item {\n//         display: block;             // take full width\n//         width: 100%;\n//         height: 100%;\n//         padding: 0.5rem;\n//         box-sizing: border-box;\n//         border-radius: 0;           // optional, remove round corners\n\n//         &:hover {\n//           background-color: #7fc5c4; // teal-like hover color\n//           cursor: pointer;\n//           color: #000;              // text color on hover\n//         }\n//       }\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
